export class IncidentRating {
  PotentialAssessment: string = "-1";
  TermsOfReference: string = "-1";
  FollowUpExecution: string = "-1";
  InvestigationQuality: string = "-1";
  FieldReview: string = "-1";
  ManagementReview: string = "-1";
}
